import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'
import { PlugToken } from '../../interfaces/common'

interface CustomTokenStore {
  customTokens: { [key: string]: PlugToken[] }
  addToken: (walletId: string, token: PlugToken) => void
  removeToken: (walletId: string, tokenId: string) => void
}

export const createCustomTokensStore = (storage: StateStorage) =>
  createStore<CustomTokenStore>(
    storage,
    (set, get) => ({
      customTokens: {},
      addToken(walletId, token) {
        const { customTokens } = get()
        const storableToken = {
          ...token,
          fee: token.fee.toString() as any,
        }

        set({
          customTokens: {
            ...customTokens,
            [walletId]: [...(customTokens[walletId] || []), storableToken],
          },
        })
      },
      removeToken(walletId, tokenId) {
        const { customTokens } = get()
        set({
          customTokens: {
            ...customTokens,
            [walletId]: (customTokens[walletId] || []).filter((tokens) => tokens.id !== tokenId),
          },
        })
      },
    }),
    {
      persist: {
        name: 'userTokens_v2',
        version: 0,
      },
    }
  )
